export default "__VITE_ASSET__DWAtcEH3__"